import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { ClockProvider } from "@/lib/clock";
import { SurpriseNotifProvider } from "@/lib/surpriseNotif";
import Layout from "@/components/wedding/Layout";
import Home from "@/pages/Home";
import Asistencia from "@/pages/Asistencia";
import Programa from "@/pages/Programa";
import Mensajes from "@/pages/Mensajes";
import MenuPage from "@/pages/MenuPage";
import Info from "@/pages/Info";
import Galeria from "@/pages/Galeria";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import WelcomeLogin from "@/pages/WelcomeLogin";

function GuestGate({ children }) {
  const { guest, checked } = useAuth();
  if (!checked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[color:var(--bg-blush)]">
        <div className="w-10 h-10 border-2 border-[color:var(--ink-wine)]/30 border-t-[color:var(--ink-wine)] rounded-full animate-spin" />
      </div>
    );
  }
  if (!guest) return <WelcomeLogin />;
  return children;
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <ClockProvider>
          <BrowserRouter>
            <SurpriseNotifProvider>
              <Toaster
                position="top-center"
                toastOptions={{
                  style: {
                    fontFamily: "Inter, sans-serif",
                    background: "#fff",
                    border: "1px solid rgba(122,31,43,0.18)",
                    color: "#3c2a2e",
                  },
                }}
              />
              <Routes>
                {/* Admin routes stay accessible without the guest gate */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<Admin />} />
                {/* All public guest routes are protected by the gate */}
                <Route
                  element={
                    <GuestGate>
                      <Layout />
                    </GuestGate>
                  }
                >
                  <Route path="/" element={<Home />} />
                  <Route path="/asistencia" element={<Asistencia />} />
                  <Route path="/programa" element={<Programa />} />
                  <Route path="/info" element={<Info />} />
                  <Route path="/mensajes" element={<Mensajes />} />
                  <Route path="/menu" element={<MenuPage />} />
                  <Route path="/galeria" element={<Galeria />} />
                  {/* Backward-compat: old /bus route redirects to home */}
                  <Route path="/bus" element={<Home />} />
                </Route>
              </Routes>
            </SurpriseNotifProvider>
          </BrowserRouter>
        </ClockProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
